import React from 'react';
import { useSearchFormStore } from '../hooks';
import { ContactUsMessage } from '../../ContactUs';

type SearchFormContactUsLinkProps = { className?: string };

export const SearchFormContactUsLink: React.FC<SearchFormContactUsLinkProps> = ({
    className,
}) => {
    const store = useSearchFormStore();

    return store.contactUsUrl ? (
        <ContactUsMessage className={className} href={store.contactUsUrl} />
    ) : null;
};
